import { render, staticRenderFns } from "./ConcernList.vue?vue&type=template&id=a0a2a79e&scoped=true"
import script from "./ConcernList.vue?vue&type=script&lang=js"
export * from "./ConcernList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a2a79e",
  null
  
)

export default component.exports